export interface PermissionsState {
  permissions: any[]
}

export const initialPermissionsState: PermissionsState = {
  permissions: []
};
